export default __webpack_public_path__ + "d0d61148830b8063bc26855dcc53efbc.svg";